import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ToolSettingModeBuilder } from '../../models/builders/tool-setting-mode.builder';

@Injectable()
export class ToolSettingModeApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }`;
  }

  getToolSettingModesByTool(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }toolSettingModes/${ hash }`).pipe(map(ToolSettingModeBuilder.fromList));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/tool-setting-mode-api.service.ts